// extracted by mini-css-extract-plugin
export default {"PokerCard":"SvgLeteleCard_PokerCard__z4R-a","ClickableCard":"SvgLeteleCard_ClickableCard__K325h"};